var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerification = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "82px",
  height: "65px",
  viewBox: "0 0 82 65",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "693EF005-9742-4844-AFBA-0E45CF2C4E44") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Log-in",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 3,
  transform: "translate(-147.000000, -163.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19",
  transform: "translate(148.000000, 164.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1205325,33.9844012 L10.1205325,54.3470639 C10.1205325,57.1304494 7.8434241,59.4075578 5.06003855,59.4075578 C2.27741205,59.4075578 0.000303614458,57.1304494 0.000303614458,54.3470639 C0.000303614458,51.5636783 2.27741205,49.2865699 5.06003855,49.2865699 L10.1205325,49.2865699",
  id: "Stroke-1",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.3852301,5.00386988 L30.6428205,5.00386988 L30.9236639,4.80652048 L35.0148687,1.9677253 L37.2919771,0.381339759 C38.0434229,-0.127214458 39.0073988,-0.127214458 39.7588446,0.381339759 L42.035953,1.9677253 L45.1252301,4.13097831 L46.3852301,5.00386988 Z",
  id: "Stroke-3",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("line", {
  x1: 59.8277602,
  y1: 14.3325,
  x2: 59.8277602,
  y2: 26.1734639,
  id: "Stroke-5",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.0060867,22.1659807 L45.1250024,36.6559807 L39.7586169,40.3448964 C39.0071711,40.8534506 38.0431952,40.8534506 37.2917494,40.3448964 L14.854641,24.776306 L11.0442795,22.1356193 C9.81464096,21.2930892 9.81464096,19.463053 11.0442795,18.5909205 L14.854641,15.9494747 L18.361388,13.5198 L18.361388,8.60200482 C18.361388,6.62092048 19.9857253,5.00417349 21.9668096,5.00417349 L56.2297012,5.00417349 C58.2107855,5.00417349 59.8275325,6.62092048 59.8275325,8.60200482 L59.8275325,14.3327277 L66.0060867,18.6212819 C67.2357253,19.463053 67.2357253,21.2930892 66.0060867,22.1659807 Z",
  id: "Stroke-7",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.361312,
  y1: 13.5201036,
  x2: 18.361312,
  y2: 26.9170916,
  id: "Stroke-9",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.9088843,39.3606542 L66.9088843,20.6329554 L66.9088843,20.5130277 C66.8785229,21.1430277 66.5787036,21.7434253 66.0086675,22.1639313 L45.1260651,36.6554494 L39.7551253,40.3458831 C39.0051976,40.8559554 38.0450169,40.8559554 37.2950892,40.3458831 L14.8519084,24.7734976 L11.041547,22.1335699 C10.4715108,21.7434253 10.1413301,21.1134253 10.1109687,20.4834253 L10.1109687,20.603353 L10.1109687,33.9844012",
  id: "Stroke-11",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.1590916,
  y1: 49.3170831,
  x2: 50.3796578,
  y2: 49.3170831,
  id: "Stroke-13",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.4047,62.3674952 L60.2239771,62.3674952 C58.0736277,62.3674952 56.4287964,60.7226639 56.4287964,58.5723145 L56.4287964,43.3915916 C56.4287964,41.2404831 58.0736277,39.5964108 60.2239771,39.5964108 L75.4047,39.5964108 C77.5550494,39.5964108 79.1998807,41.2404831 79.1998807,43.3915916 L79.1998807,58.5723145 C79.1998807,60.7226639 77.4290494,62.3674952 75.4047,62.3674952 Z",
  id: "Stroke-15",
  stroke: "#FF176A",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-17",
  stroke: "#252525",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  points: "60.7932542 51.5652723 64.841194 55.487212 74.8354229 45.4929831"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerification);
export default ForwardRef;